/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { prepScopes } from '../utils/GraphHelpers';
/**
 * Group Type enumeration
 *
 * @export
 * @enum {number}
 */
export var GroupType;
(function (GroupType) {
    /**
     * Any group Type
     */
    GroupType[GroupType["Any"] = 0] = "Any";
    /**
     * Office 365 group
     */
    // tslint:disable-next-line:no-bitwise
    GroupType[GroupType["Unified"] = 1] = "Unified";
    /**
     * Security group
     */
    // tslint:disable-next-line:no-bitwise
    GroupType[GroupType["Security"] = 2] = "Security";
    /**
     * Mail Enabled Security group
     */
    // tslint:disable-next-line:no-bitwise
    GroupType[GroupType["MailEnabledSecurity"] = 4] = "MailEnabledSecurity";
    /**
     * Distribution Group
     */
    // tslint:disable-next-line:no-bitwise
    GroupType[GroupType["Distribution"] = 8] = "Distribution";
})(GroupType || (GroupType = {}));
/**
 * Searches the Graph for Groups
 *
 * @export
 * @param {IGraph} graph
 * @param {string} query - what to search for
 * @param {number} [top=10] - number of groups to return
 * @param {GroupType} [groupTypes=GroupType.Any] - the type of group to search for
 * @returns {Promise<Group[]>} An array of Groups
 */
export function findGroups(graph, query, top = 10, groupTypes = GroupType.Any) {
    return __awaiter(this, void 0, void 0, function* () {
        const scopes = 'Group.Read.All';
        let filterQuery = `(startswith(displayName,'${query}') or startswith(mailNickname,'${query}') or startswith(mail,'${query}'))`;
        if (groupTypes !== GroupType.Any) {
            const filterGroups = [];
            // tslint:disable-next-line:no-bitwise
            if (GroupType.Unified === (groupTypes & GroupType.Unified)) {
                filterGroups.push("groupTypes/any(c:c+eq+'Unified')");
            }
            // tslint:disable-next-line:no-bitwise
            if (GroupType.Security === (groupTypes & GroupType.Security)) {
                filterGroups.push('(mailEnabled eq false and securityEnabled eq true)');
            }
            // tslint:disable-next-line:no-bitwise
            if (GroupType.MailEnabledSecurity === (groupTypes & GroupType.MailEnabledSecurity)) {
                filterGroups.push('(mailEnabled eq true and securityEnabled eq true)');
            }
            // tslint:disable-next-line:no-bitwise
            if (GroupType.Distribution === (groupTypes & GroupType.Distribution)) {
                filterGroups.push('(mailEnabled eq true and securityEnabled eq false)');
            }
            filterQuery += ' and ' + filterGroups.join(' or ');
        }
        const result = yield graph
            .api('groups')
            .filter(filterQuery)
            .top(top)
            .middlewareOptions(prepScopes(scopes))
            .get();
        return result ? result.value : null;
    });
}
//# sourceMappingURL=graph.groups.js.map